'use client'
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "react-router-dom"; // For internal links in React

const swiperOptions = {
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    loop: true,

    // Navigation
    navigation: {
        nextEl: '.h1n',
        prevEl: '.h1p',
    },

    // Pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
}

export default function Banner() {
    return (
        <>
            <section id="banner" className="banner-section">
                <Swiper {...swiperOptions} className="banner-carousel theme_carousel owl-theme">
                    <SwiperSlide className="slide-item">
                        <div className="swiper-slide" style={{ backgroundImage: 'url(assets/images/main-slider/suite-banner.jpg)' }}>
                            <div className="content-outer">
                                <div className="content-box">
                                    <div className="inner">
                                        <h4>Change The World</h4>
                                        <h1>Sha Care  <br /></h1>
                                        <div className="text">The Best NDIS (National Disability Insurance Scheme) and DVA (Department of Veterans' Affairs) Provider<br /> Reach Us Out.</div>
                                        <div className="link-box">
                                            {/* Use Link for React Router navigation */}
                                            {/* <Link to="/service" className="btn-1 btn-large">Discover More <span></span></Link> */}
                                            <a href="https://service.shacaresupport.com.au"  className="btn-1 btn-large">Discover More</a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="slide-item">
                        <div className="swiper-slide" style={{ backgroundImage: 'url(assets/images/main-slider/suite-banner2.jpg)' }}>
                            <div className="content-outer">
                                <div className="content-box">
                                    <div className="inner">
                                    <h4>Change The World</h4>
                                        <h1>Sha Care  <br /></h1>
                                        <div className="text">The Best NDIS (National Disability Insurance Scheme) and DVA (Department of Veterans' Affairs) Provider<br /> Reach Us Out.</div>

                                        <div className="link-box">
                                            {/* Use Link for React Router navigation */}
                                            {/* <Link to="/service" className="btn-1 btn-large">Discover More <span></span></Link> */}
                                            <a href="https://service.shacaresupport.com.au"  className="btn-1 btn-large">Discover More</a>
                                        </div>
                                    </div>                               
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <div className="banner-shape">
                        <img src="assets/images/shape/banner-shape.svg" alt="" />
                    </div>
                </Swiper>
            </section>
        </>
    )
}
